import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    question: "Are you fully licensed and insured?",
    answer:
      "Yes. We're NICEIC registered and Part P certified, and we carry public liability insurance up to £2 million, so every job is covered from start to finish.",
  },
  {
    question: "Do you offer free quotes?",
    answer:
      "Absolutely. We provide free, no-obligation quotes for all jobs, big or small. Just fill out the form above or give us a call and we'll arrange a time to take a look.",
  },
  {
    question: "What areas do you cover?",
    answer:
      "We cover Blackpool, Lytham, Lytham St Annes, Saint Anne's, Mereside, Bispham, Layton, Weeton, Poulton-le-Fylde, Fleetwood, Cleveleys, Thornton-Cleveleys, Garstang, Preesall, Hambleton and Preston. Not sure if you're in our patch? Give us a call and we'll let you know.",
  },
  {
    question: "Do you offer emergency call-outs?",
    answer:
      "Yes, we run a 24/7 emergency electrical service for urgent issues like power loss, sparking sockets or tripped circuits that won't reset.",
  },
  {
    question: "How quickly can you start my job?",
    answer:
      "For standard jobs we can usually get started within a few days of your quote being accepted. Emergency call-outs are prioritised and attended same-day wherever possible.",
  },
  {
    question: "Do you provide a guarantee on your work?",
    answer:
      "Every job is backed by our workmanship guarantee, and we issue the correct certification (EIC, EICR or Minor Works Certificate) for full peace of mind.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="scroll-mt-20 bg-background py-20">
      <div className="mx-auto max-w-360 px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold tracking-wider text-primary uppercase">
            FAQ
          </span>
          <h2 className="mt-2 text-3xl font-bold sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-muted-foreground">
            Got a question that isn't answered here? Get in touch and we'll
            be happy to help.
          </p>
        </div>
        <Accordion type="single" collapsible className="mx-auto mt-12 max-w-3xl">
          {faqs.map((faq, i) => (
            <AccordionItem key={faq.question} value={`item-${i}`} className="border-white/10">
              <AccordionTrigger className="text-left text-base font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
